import { css } from '@emotion/react'
import { Alert, Cell, Flow, Grid, InfoLabel, Text } from 'bold-ui'
import { Telefone } from 'components/label'
import { humanizeDate } from 'util/date/humanize-date'
import { isTipoImovelDomicilio } from 'view/cadastro-imovel/utils-cadastroImovel'
import { ResponsavelTecnicoImovelList } from 'view/visualizacaoTerritorial/components/list/ResponsavelTecnicoImovelList'
import {
  getBairroFormatado,
  getImovelCepFormatado,
} from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { TerritorioMapaFamiliaResidenteModel, TerritorioMapaImovelModel } from '../model-territorioMapa'
import { PinoTerritorioModalFamiliaSection } from './PinoTerritorioModalFamiliaSection'

interface PinoTerritorioModalBodyProps {
  imovel: TerritorioMapaImovelModel
  dataUltimaAtualizacao: number | undefined
  familiasResidentes: TerritorioMapaFamiliaResidenteModel[]
  isFichaProcessada: boolean
}

export function PinoTerritorioModalBody(props: Readonly<PinoTerritorioModalBodyProps>) {
  const { imovel, dataUltimaAtualizacao, familiasResidentes, isFichaProcessada } = props

  const isDomicilio = imovel.tipoImovel && isTipoImovelDomicilio(imovel.tipoImovel)

  return (
    <Flow direction='vertical' gap={2}>
      <Grid gapVertical={0.5}>
        <Cell size={3}>
          <InfoLabel title='CEP'>{imovel.cep && <Text>{getImovelCepFormatado(imovel.cep)}</Text>}</InfoLabel>
        </Cell>
        <Cell size={3}>
          <InfoLabel title='Bairro'>{imovel.bairro && <Text>{getBairroFormatado(imovel.bairro)}</Text>}</InfoLabel>
        </Cell>
        <Cell size={3}>
          <InfoLabel title='Telefone'>
            {imovel.telefoneContato && <Telefone value={imovel.telefoneContato} />}
            {!imovel.telefoneContato && imovel.telefoneResidencial && <Telefone value={imovel.telefoneResidencial} />}
          </InfoLabel>
        </Cell>
        <Cell size={3}>
          <InfoLabel title='Última atualização'>
            {dataUltimaAtualizacao ? <Text>{humanizeDate(dataUltimaAtualizacao)}</Text> : 'Desconhecida'}
          </InfoLabel>
        </Cell>
        {!isFichaProcessada && (
          <Cell size={12}>
            <Alert type='info' inline>
              Existem fichas ainda não processadas para este imóvel
            </Alert>
          </Cell>
        )}
      </Grid>
      {imovel.responsavelTecnico && <ResponsavelTecnicoImovelList responsavelTecnico={imovel.responsavelTecnico} />}
      {isDomicilio && !familiasResidentes.length && (
        <Text fontStyle='italic' style={styles.semFamiliaText}>
          Sem registro de família cadastrada.
        </Text>
      )}
      {isDomicilio && familiasResidentes.length > 0 && (
        <Flow direction='vertical' gap={0.75}>
          {familiasResidentes.map((familiaResidente) => (
            <PinoTerritorioModalFamiliaSection familiaResidente={familiaResidente} key={familiaResidente.id} />
          ))}
        </Flow>
      )}
    </Flow>
  )
}

const styles = {
  semFamiliaText: css`
    text-align: center;
  `,
}
